export enum LocaleId {
  default,
  US = 1,
  ChinaChinese = 3,
  ChinaEnglish = 4,
  AustraliaEnglish = 28,
  NewZealandEnglish = 29,
}
